import { AnswerSource, AnswerStats, BaseStats, SurveyStatus } from "../../../redux/survey/survey.types";
import { orderBy } from "lodash";

const { AI, Human } = AnswerSource;
const percentageKey = (source: AnswerSource): keyof BaseStats => {
  switch (source) {
    case Human:
      return "humanPercentage";
    case AI:
      return "aiPercentage";
    default:
      return "totalPercentage";
  }
};

const countKey = (source: AnswerSource): keyof BaseStats => {
  switch (source) {
    case Human:
      return "humanUsers";
    case AI:
      return "aiUsers";
    default:
      return "totalUsers";
  }
};

const sortAnswers = (answers: AnswerStats[], source: AnswerSource) => {
  return orderBy(answers, countKey(source), 'desc');
};

const maxAnswerPercentage = (answers: AnswerStats[], source: AnswerSource) => {
  const percentages: number[] = [];
  answers.forEach(answer => {
    const stat = answer[percentageKey(source)];
    if (typeof stat === "number") {
      percentages.push(stat);
    }
  });
  return Math.max(...percentages);
};

const answerTitle = (baseTitle: string, index: number, surveyStatus?: SurveyStatus) => {
  if (surveyStatus === SurveyStatus.Complete) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return characters[index] + ') ' + (baseTitle !== null ? baseTitle : '');
  }
  return baseTitle;
};

export { percentageKey, countKey, sortAnswers, maxAnswerPercentage, answerTitle };
